// extracted by mini-css-extract-plugin
export default {"tag":"styles_tag__U++Un","tagInfo":"styles_tagInfo__uKtCu","tagAlert":"styles_tagAlert__5KZuA","tagDisabled":"styles_tagDisabled__AlDHF"};